import { render, staticRenderFns } from "./CompRequiresAction.vue?vue&type=template&id=038b61bc"
import script from "./CompRequiresAction.vue?vue&type=script&lang=js"
export * from "./CompRequiresAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports